import { DateTime } from "luxon";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import { backendDateOrDateTimeToLuxonDateTime } from "../../../../../utils/dates/backendDateOrDateTimeToLuxonDateTime";
import { MONTH_YEAR_FORMAT } from "../../../../../utils/dates/dates.constants";
import { sortBackendDates } from "../../../../../utils/dates/sortBackendDates";
import type { EnergyRevenuesCellCheckStateResponse } from "../../../RevenueMonitoring.types";

export function getPeriodStartColumn(): MRT_ColumnDef<EnergyRevenuesCellCheckStateResponse> {
  return {
    header: "Monat",
    id: "period_start",
    accessorFn: (row) =>
      backendDateOrDateTimeToLuxonDateTime(row.period_start).toLocaleString(
        MONTH_YEAR_FORMAT
      ),
    filterVariant: "multi-select",
    sortingFn: (rowA, rowB) =>
      sortBackendDates(rowA.original.period_start, rowB.original.period_start),
    mantineFilterMultiSelectProps: ({ column }) => ({
      data: Array.from(column.getFacetedUniqueValues().keys()).sort((a, b) => {
        return (
          DateTime.fromFormat(a, "MMM yyyy").toJSDate().getTime() -
          DateTime.fromFormat(b, "MMM yyyy").toJSDate().getTime()
        );
      })
    }),
    enableColumnFilterModes: false,
    enableEditing: false,
    size: 120
  };
}
